export default __webpack_public_path__ + "static/media/cult-logo-white.b2fec1e8.svg";